
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getDatabase } from "firebase/database";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDpH8C9e1LomikP3VXTe_y-bxgTRZhGj-A",
  authDomain: "easyforms-22f72.firebaseapp.com",
  projectId: "easyforms-22f72",
  storageBucket: "easyforms-22f72.appspot.com",
  messagingSenderId: "887177467383",
  appId: "1:887177467383:web:969b04121b243efeb90af2",
  measurementId: "G-LD4ECFMRJM",
  databaseURL: "https://easyforms-22f72-default-rtdb.firebaseio.com"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const database = getDatabase(app);